import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEPetroleumCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Petroleum Engineering",
    shortName: "B.E. Petroleum",
    duration: "4 years",
    description: "Specialized engineering program focused on exploration, extraction, and production of oil and gas resources",
    overview: "Bachelor of Engineering in Petroleum Engineering (B.E. Petroleum) is a 4-year undergraduate program that deals with the exploration, drilling, extraction, and production of oil and natural gas. This course covers reservoir engineering, drilling technology, production optimization, and petroleum geology, preparing students for careers in the oil and gas industry.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in geology and petroleum sciences"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Petroleum Engineering",
          "Earth Sciences"
        ]
      },
      {
        year: 2,
        subjects: [
          "Petroleum Geology",
          "Rock and Fluid Properties",
          "Drilling Engineering",
          "Fluid Mechanics",
          "Thermodynamics",
          "Materials Science"
        ]
      },
      {
        year: 3,
        subjects: [
          "Reservoir Engineering",
          "Production Engineering",
          "Well Testing",
          "Enhanced Oil Recovery",
          "Petroleum Refining",
          "Formation Evaluation"
        ]
      },
      {
        year: 4,
        subjects: [
          "Offshore Engineering",
          "Natural Gas Engineering",
          "Petroleum Economics",
          "Environmental Engineering",
          "Project Work",
          "Field Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Petroleum Engineer",
        "Drilling Engineer",
        "Reservoir Engineer",
        "Production Engineer",
        "Completion Engineer",
        "Geologist",
        "Field Engineer",
        "Operations Engineer",
        "Technical Consultant",
        "Project Manager"
      ],
      industries: [
        "Oil and Gas Companies",
        "Petroleum Exploration Companies",
        "Drilling Contractors",
        "Oilfield Service Companies",
        "Petroleum Refining",
        "Natural Gas Companies",
        "Offshore Engineering",
        "Government Organizations",
        "Consulting Services",
        "Research Institutions"
      ],
      averageSalary: "₹8-18 LPA (Fresher), ₹25-80 LPA (Experienced)",
      topRecruiters: [
        "ONGC, OIL, GAIL",
        "Reliance Industries, Cairn",
        "Halliburton, Schlumberger",
        "Baker Hughes, Weatherford",
        "Essar Oil, HPCL",
        "IOCL, BPCL"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Pandit Deendayal Energy University",
        location: "Gujarat",
        fees: "₹4,00,000",
        ranking: "Specialized in Energy"
      },
      {
        name: "University of Petroleum and Energy Studies",
        location: "Dehradun",
        fees: "₹15,60,000",
        ranking: "NAAC A Grade"
      },
      {
        name: "Rajiv Gandhi Institute of Petroleum Technology",
        location: "Uttar Pradesh",
        fees: "₹8,00,000",
        ranking: "Institute of National Importance"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹12,00,000",
        ranking: "NIRF Ranking: 41"
      }
    ],

    skills: [
      "Reservoir Simulation",
      "Drilling Software (WELLPLAN, COMPASS)",
      "Geological Modeling",
      "Production Optimization",
      "MATLAB/Eclipse",
      "Well Design",
      "Formation Evaluation",
      "Petroleum Economics",
      "Safety and Environmental Standards",
      "Project Management"
    ],

    futureScope: "Strong prospects with India's growing energy demands, offshore exploration, unconventional resources, and transition to cleaner energy technologies requiring petroleum engineering expertise.",

    faqs: [
      {
        question: "Is Petroleum Engineering affected by renewable energy growth?",
        answer: "While renewable energy is growing, oil and gas will remain important for decades. Petroleum engineers are also adapting to work in geothermal, carbon capture, and hydrogen energy sectors."
      },
      {
        question: "Are there opportunities for international work?",
        answer: "Yes, petroleum engineering offers excellent international opportunities with multinational oil companies and projects in oil-rich countries worldwide."
      },
      {
        question: "What about offshore opportunities?",
        answer: "India has significant offshore oil and gas reserves. Offshore engineering is a growing field with opportunities in ONGC, Reliance, and international offshore companies."
      },
      {
        question: "Is the work dangerous?",
        answer: "Modern petroleum operations emphasize safety heavily. Engineers work with strict safety protocols, and much work involves design, analysis, and management rather than field operations."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEPetroleumCoursePage;
